import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-211">
      <div className="max-w-3xl mx-auto" data-id="element-212">
        <div className="text-center" data-id="element-213">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-214">
            💡 Presentamos
          </h2>
          <h3 className="text-4xl md:text-6xl font-black text-red-600 mb-4" data-id="element-215">
            ❤️ PACK 100 CITAS
          </h3>
          <p className="text-gray-500 italic mb-8" data-id="element-216">
            El sistema que transforma ratos libres en recuerdos que duran toda
            la vida.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-dashed border-blue-200 mb-12" data-id="element-217">
            <p className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-218">
              Un sistema simple de momentos guiados diseñado para que conectes
              de verdad con tus hijos — sin esfuerzo, sin pantallas y sin
              excusas.
            </p>
            <ul className="text-left space-y-4 text-lg text-gray-600 max-w-xl mx-auto font-medium" data-id="element-219">
              <li className="flex items-start gap-3" data-id="element-220">
                <span className="text-red-500" data-id="element-221">❌</span> No es un libro teórico
                que vas a dejar en un cajón.
              </li>
              <li className="flex items-start gap-3" data-id="element-222">
                <span className="text-red-500" data-id="element-223">❌</span> No es un manual largo
                que nunca vas a terminar.
              </li>
              <li className="flex items-start gap-3 text-gray-900 font-bold bg-yellow-100 p-2 rounded" data-id="element-224">
                <span className="text-green-500" data-id="element-225">✅</span> Es un sistema
                práctico que podés usar hoy mismo. Abrís, elegís y conectás.
              </li>
            </ul>
          </div>

          <h3 className="text-3xl font-black text-gray-900 mb-2" data-id="element-226">
            Así de simple funciona
          </h3>
          <p className="text-gray-500 mb-10" data-id="element-227">
            En 3 pasos ya estás creando recuerdos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-228">
            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-blue-500" data-id="element-229">
              <div className="text-4xl mb-4" data-id="element-230">📖</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-231">
                Abrís el libro
              </h4>
              <p className="text-gray-600" data-id="element-232">
                Sin complicaciones.
                <br data-id="element-233" />
                Sin preparar nada.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-yellow-500 relative" data-id="element-234">
              <div className="absolute -right-4 top-1/2 transform -translate-y-1/2 hidden md:block text-gray-300 text-4xl" data-id="element-235">
                ➔
              </div>
              <div className="text-4xl mb-4" data-id="element-236">👆</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-237">
                Elegís una cita
              </h4>
              <p className="text-gray-600" data-id="element-238">
                Actividades pensadas para cada vínculo.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-red-500 relative" data-id="element-239">
              <div className="absolute -left-4 top-1/2 transform -translate-y-1/2 hidden md:block text-gray-300 text-4xl" data-id="element-240">
                ➔
              </div>
              <div className="text-4xl mb-4" data-id="element-241">❤️</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-242">
                Vivís el momento
              </h4>
              <p className="text-gray-600" data-id="element-243">
                Sin pantallas.
                <br data-id="element-244" />
                Sin estrés.
                <br data-id="element-245" />
                <span className="font-bold text-red-600" data-id="element-246">
                  Solo conexión real con tus hijos.
                </span>
              </p>
            </div>
          </div>

          <p className="text-gray-500 italic text-sm mb-8" data-id="element-247">
            "No necesitás ser el padre perfecto. Solo necesitás estar presente."
          </p>

          <CTAButton text="👉 QUIERO EMPEZAR A CREAR RECUERDOS HOY" data-id="element-248" />
        </div>
      </div>
    </section>;
}